/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { ChannelCallbacks, VcClient } from "../vc-client";

@Injectable()
export class VcClientSdk extends VcClient {
   protected optionString;

   constructor() {
      super();
   }

   public initSDK = (uuid: string, channelOptions: string, callbacks: ChannelCallbacks) => {
      this.init(uuid, channelOptions, callbacks);
      this.uuid = uuid;
      this.logger.info("vchan string set as " + this.optionString);
   };
}
